import { getLogger } from 'amkit3-modules/utils/log4js'
import xss from 'amkit3-modules/utils/xss'
import storage from 'amkit3-modules/utils/storage'
// import raf from 'amkit3-modules/utils/raf'
import {
  DANMU_SIZE,
  DANMU_POSITION,
  DEFAULT_DANMU_SIZE,
  DEFAULT_DANMU_OPACITY,
  DEFAULT_DANMU_POSITION,
  DEFAULT_DANMU_TYPE,
} from 'amkit3-modules/v/danmu/danmu-config'
const logger = getLogger('v/danmu/huya/comments')

const MARGIN_HEIGHT = 3
const MARGIN_RIGHT = 10
const ROW_HEIGHT = 27
const DANMU_SPEED = [100, 150, 200]

const baseTime = 10000

let raf = cb => window.setTimeout(cb, 300)

raf.cancel = id => clearTimeout(id)

let hidden
let visibilityChange
if (typeof document.hidden !== 'undefined') {
  // Opera 12.10 and Firefox 18 and later support
  hidden = 'hidden'
  visibilityChange = 'visibilitychange'
} else if (typeof document.msHidden !== 'undefined') {
  hidden = 'msHidden'
  visibilityChange = 'msvisibilitychange'
} else if (typeof document.webkitHidden !== 'undefined') {
  hidden = 'webkitHidden'
  visibilityChange = 'webkitvisibilitychange'
}

class HuyaDanmuComments {
  constructor($, $container) {
    this.$ = $
    this.$container = $container
    this.style = require('./style.scssm')
    this.channels = []
    this.waitList = []
    this.paused = false
    this.visible = true
    this.enable = true
    this.size = DANMU_SIZE[DEFAULT_DANMU_SIZE]
    this.opacity = DEFAULT_DANMU_OPACITY
    this.position = DEFAULT_DANMU_POSITION
    this.type = DEFAULT_DANMU_TYPE
    this.animateCb = () => {
      // logger.debug('animateCb start')
      if (this.enable) {
        this.judgeChannelCanUse()
      }
      if (!this.paused) {
        this.animationId = raf(this.animateCb)
      }
    }
    this.$container.css('opacity', this.opacity / 100)

    // 播放器不在显示中，移除等待弹幕
    document.addEventListener(
      visibilityChange,
      () => {
        if (document[hidden]) {
          // videoElement.pause();
          this.visible = false
          this.waitList = []
        } else {
          this.visible = true
        }
      },
      false,
    )
  }

  setPosition(position) {
    logger.debug('setPosition', position)
    this.position = position
    localStorage.setItem('danmuPosition', this.position)
  }

  setOpacity(opacity) {
    opacity = Number(opacity)
    var limits = [5, 100]
    logger.debug('setOpacity', opacity)
    this.opacity = Math.max(Math.min(limits[1], opacity), limits[0])
    this.$container.css('opacity', this.opacity / 100)
  }

  setCookieOpacity(opacity) {
    localStorage.setItem('danmuOpacity', parseInt(opacity, 10))
    logger.debug('setCookieOpacity', opacity)
  }

  setFontSize(size) {
    logger.debug('setFontSize', size)
    localStorage.setItem('videoDanmuSizeMode', size)
    this.size = DANMU_SIZE[size]
  }

  setDanmuType(type) {
    logger.debug('setDanmuType', type)
    localStorage.setItem('danmuType', type)
    this.type = type
  }

  pause() {
    if (this.paused) return

    this.paused = true

    this.pauseAnimate()
    logger.debug('pauseAnimate', this.paused)
    raf.cancel(this.animationId)
    this.animationId = null
  }
  resume() {
    if (!this.paused) return
    this.paused = false
    // this.prevAnimateTime = new Date().valueOf()
    this.animateCb()
    this.resumeAnimate()
    logger.debug('resumeAnimate', this.paused)
    this.remove()
  }

  remove() {
    if (this.timeInter) return
    this.timeInter = setInterval(() => {
      logger.debug('danmu ku remove ', Date.now())
      this.channels.forEach(channel =>
        channel.comments.forEach(($comment, index) => {
          let duration = $comment.data('to-position')
          let position = $comment.offset().left
          if (position < 0 && position + $comment.width() <= 0) {
            $comment.remove()
            channel.comments.splice(index, 1)
          }
        }),
      )
      if (this.channels.length === 0 || this.paused) {
        clearInterval(this.timeInter)
        this.timeInter = null
      }
    }, 10000)
  }

  push(commentItems) {
    // 如果播放器不在显示中，不添加弹幕
    if (!this.visible) return

    logger.debug('push commentItems', commentItems)

    commentItems.forEach(commentItem => {
      if (this.type.indexOf(commentItem.danmuType) >= 0) {
        this.waitList.push(commentItem)
      }
    })

    if (!this.animationId) {
      this.animateCb()
    }
  }

  clear() {
    // raf.cancel(this.animationId)
    this.channels.forEach(channel =>
      channel.comments.forEach($comment => {
        $comment.remove()
      }),
    )
    this.channels = []
  }

  calcPosition(index) {
    var maxHeight =
      Math.floor((this.$container.height() - MARGIN_HEIGHT) / ROW_HEIGHT) * ROW_HEIGHT || 0
    var danmuPosition = DANMU_POSITION[this.position]
    var maxRange = (danmuPosition[1] - danmuPosition[0]) * maxHeight

    var y = maxHeight * danmuPosition[0] + ROW_HEIGHT * (index % maxRange) + MARGIN_HEIGHT

    return y
  }

  requestChannel($comment) {
    let result
    let containerWidth = this.$container.width()
    let maxLength = Math.floor((this.$container.height() - MARGIN_HEIGHT) / ROW_HEIGHT)
    let maxHeight = maxLength * ROW_HEIGHT || 0
    let danmuPosition = DANMU_POSITION[this.position]
    let maxRange = (danmuPosition[1] - danmuPosition[0]) * maxHeight
    let limitLength = Math.floor(maxRange / ROW_HEIGHT)

    let shortestOffset = 0
    let shortestPosition = this.$container.offset().left + containerWidth
    let shortestChannel = 0

    // debugger;

    for (let i = 0; i < maxLength; i++) {
      if (i < limitLength) {
        let channel = this.channels[i]
        if (!channel) {
          channel = { index: i, comments: [] }
          this.channels.push(channel)
        }
        let comments = channel.comments
        if (!comments.length) {
          result = channel
          break
        } else {
          let $lastComment = comments[comments.length - 1]

          let lastWidth = Number($lastComment.data('width'))
          let lastOffsetLeft = Number($lastComment.offset().left)
          let lastPosition = lastOffsetLeft + lastWidth + 15
          let lastCommentRemainTime = lastPosition / Number($lastComment.data('speed'))

          // 判断当前弹幕的频道是否位置空余并且无阻赛
          console.log('i:', i, ', lastPosition:', lastPosition, ', sortest post:', shortestPosition)
          if (lastPosition <= shortestPosition) {
            result = channel
            break
          } else {
            let commentRemainTime = Number(
              $comment.data('prev-position') / Number($comment.data('speed')),
            )
            if (lastCommentRemainTime < commentRemainTime) {
              result = channel
              break
            } else {
              if (shortestOffset === 0 || shortestOffset > lastOffsetLeft) {
                shortestOffset = lastOffsetLeft
                shortestChannel = i
                shortestPosition = lastPosition
              }
            }
          }
        }
      }
    }

    if (!result) {
      //if (shortestChannel!=-1) {
      result = this.channels[shortestChannel]
      // }
    }

    let x = shortestPosition
    let y = maxHeight * danmuPosition[0] + ROW_HEIGHT * result.index + MARGIN_HEIGHT

    $comment.data('channel', result.index)
    $comment.data('x', x)
    $comment.data('y', y)

    return result
    // var y = (maxHeight * danmuPosition[0]) + ROW_HEIGHT * (index % maxRange) + MARGIN_HEIGHT
  }

  pauseAnimate() {
    //this.$container.css('display','none')
    // this.$container.find('div').css({ 'transition-property':'none', 'transition-duration':'0ms'})
    this.channels.forEach(channel =>
      channel.comments.forEach(($comment, index) => {
        var prevPosition = Number($comment.data('prev-position'))
        var duration = -$comment.data('x') // Number($comment.data('to-position'))
        var speed = Number($comment.data('speed'))
        var left = $comment.offset().left
        var position = left - this.$container.offset().left

        // logger.debug('comment', $comment.text(),',offset left:',  $comment.offset().left)

        if (position + $comment.width() >= 0) {
          $comment.data('offsetLeft', left)
          $comment.data('prev-position', position)
          $comment.css('transition-property', 'none')
          $comment.css('transition-duration', '0ms')
          $comment.css('animation-play-state', 'paused')
          $comment.css(
            'transform',
            'translateX(' + (position + duration) + 'px) translateY(0px) translateZ(0)',
          )
        } else {
          // logger.debug('comment', $comment.text(),',offset left:',  $comment.offset().left)
          //$comment.remove()
          // channel.comments.splice(index, 1)
        }
      }),
    )
    // this.$container.css('display','block')
  }

  resumeAnimate() {
    this.$container.css('display', 'none')
    this.channels.forEach(channel =>
      channel.comments.forEach(($comment, index) => {
        var prevPosition = Number($comment.data('prev-position'))
        var duration = Number($comment.data('to-position'))
        var speed = Number($comment.data('speed'))
        var position = Number($comment.data('offsetLeft')) //$comment.offset().left
        var time = Number($comment.data('time'))
        var dtime = ((position + $comment.data('width')) / Math.abs(duration)) * time

        if (position > 0 || position + $comment.data('width') >= 0) {
          $comment.css('transition-property', 'transform')
          $comment.css('transition-duration', dtime + 'ms')
          // $comment.css('transition-duration', time + 'ms');
          $comment.css('animation-play-state', 'running')
          $comment.css('transform', 'translateX(' + duration + 'px) translateY(0px) translateZ(0)')

          $comment.data('prev-position', position)
        } else {
          //$comment.remove()
          // channel.comments.splice(index, 1)
        }
      }),
    )
    this.$container.css('display', 'block')
  }

  requestComment(commentItem, channel, y) {
    let containerWidth = this.$container.width()
    let containerLeft = this.$container.offset().left
    var $comment = this.$('<div></div>')
    $comment.text(xss(commentItem.text))
    $comment.addClass(this.style.danmuComment)
    if (commentItem.highlight) {
      $comment.addClass(this.style.danmuCommentHighlight)
    }
    $comment.data('id', commentItem.id)
    $comment.data('playTime', commentItem.playTime)
    $comment.data('text', commentItem.text)
    $comment.data('container-left', containerLeft)

    this.$container.append($comment)

    var commentWidth = $comment.width()
    var prevPosition = containerWidth + 1.4 * commentWidth

    // 获取宽度后隐藏进行操作，减少重排
    $comment.css('display', 'none')
    $comment.data('prev-position', prevPosition)
    $comment.data('width', commentWidth)
    $comment.css('left', containerLeft + containerWidth + 'px')

    // var channel = this.requestChannel($comment)

    $comment.data('size', this.size)

    let x = containerLeft + containerWidth
    // let y = ROW_HEIGHT * channel.index

    let position = -(x + 1.4 * commentWidth)
    let speed = (x + 1.4 * commentWidth) / 10000
    let time = (x / containerWidth) * baseTime // Math.abs(position  / commentWidth * 500)

    $comment.data('x', x)
    $comment.data('y', y)
    $comment.data('speed', speed)
    $comment.data('time', time)
    $comment.data('to-position', position)

    // logger.debug(
    //   'comment add',
    //   commentItem.text,
    //   'request channel',
    //   channel.index,
    //   'x is',
    //   x,
    //   'y is',
    //   y,
    // )

    $comment.css('top', y + 'px')
    $comment.css('top', y + 'px')
    const fSize = this.size >= 20 ? this.size : DANMU_SIZE[DEFAULT_DANMU_SIZE]
    $comment.css('font-size', fSize + 'px')
    $comment.css('transition-duration', (this.paused ? 0 : time) + 'ms')
    $comment.css('left', x + 'px')
    $comment.css('transform', 'translateX(' + position + 'px) translateY(0px) translateZ(0px)')

    channel.comments.push($comment)
    // 显示进入队列
    $comment.css('display', 'block')
  }

  clearFinishComments() {
    // const containerOffsetLeft = this.$container.offset().left
    this.channels.forEach(channel => {
      channel.comments = []
    })
    this.$container.empty()
  }

  // 判断通道是否可用
  judgeChannelCanUse() {
    if (this.waitList.length === 0) return

    logger.debug('waitList', this.waitList)

    let containerWidth = this.$container.width()
    let containerOffsetLeft = this.$container.offset().left
    const containerLeft = containerOffsetLeft + containerWidth
    let maxLength = Math.floor((this.$container.height() - MARGIN_HEIGHT) / ROW_HEIGHT)
    let danmuPosition = DANMU_POSITION[this.position]
    let maxHeight = maxLength * ROW_HEIGHT || 0
    let maxRange = (danmuPosition[1] - danmuPosition[0]) * maxHeight

    let limitLength = Math.floor(maxRange / ROW_HEIGHT)
    // logger.debug('danmu max length', maxLength, limitLength)
    for (let i = 0; i < maxLength; i++) {
      if (i < limitLength) {
        let channel = this.channels[i]
        if (!channel) {
          channel = { index: i, comments: [] }
          this.channels.push(channel)
        }
        let comments = channel.comments
        const y = maxHeight * danmuPosition[0] + ROW_HEIGHT * channel.index + MARGIN_HEIGHT
        if (!comments.length) {
          let commentItem = this.waitList.shift()
          // logger.debug('comments is null:', commentItem.text, containerLeft, width)
          if (!commentItem) return
          if (this.type.indexOf(commentItem.danmuType) >= 0) {
            this.requestComment(commentItem, channel, y)
          }
        } else {
          let $firstComment = comments[0]

          let firstWidth = Number($firstComment.data('width'))
          let firstOffsetLeft = Number($firstComment.offset().left)

          let $lastComment = comments[comments.length - 1]
          let lastWidth = Number($lastComment.data('width'))
          let lastOffsetLeft = Number($lastComment.offset().left)

          const position = lastWidth + lastOffsetLeft + MARGIN_RIGHT

          // logger.debug('comments position:', commentItem.text, containerLeft, width)
          if (firstWidth + firstOffsetLeft <= containerOffsetLeft) {
            comments.shift()
            $firstComment.remove()
          }
          if (position <= containerLeft) {
            let commentItem = this.waitList.shift()
            if (!commentItem) return
            if (this.type.indexOf(commentItem.danmuType) >= 0) {
              this.requestComment(commentItem, channel, y)
            }
          }
        }
      }
    }
  }
}

export default HuyaDanmuComments
